

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Network from '../../Utils/network.js';
import TableComponent from '../../Utils/tableComponent.js';
import { Button } from 'reactstrap';
import NoDataFound from '../../Utils/noDataFound.js';
import completed from '../../ImageAssets/Icon_White_3.png';
import inprogress from '../../ImageAssets/Icon_White_2.png';
import open from '../../ImageAssets/Icon_White_1.png';
import total from '../../ImageAssets/Icon_White_4.png';
import completedGrey from '../../ImageAssets/Icon_Grey_3.png';
import inprogressGrey from '../../ImageAssets/Icon_Grey_2.png';
import openGrey from '../../ImageAssets/Icon_Grey_1.png';
import totalGrey from '../../ImageAssets/Icon_Grey_4.png';
import Swal from 'sweetalert2';
import SliderModal from '../../Utils/sliderModal.js';
import ValidateForm from '../../Utils/formValidation';
import viewIcon from '../../ImageAssets/viewIcon.png';
import Email from '../../ImageAssets/email.png';
import PhoneBlk from '../../ImageAssets/phoneblk.png';

class ServiceCenterComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            tickets: [],
            billingName: "NA",
            profileId: "",
            contactNumber: "",
            emailId: "NA",
            addressLine1: "",
            state: "",
            city: "",
            zipCode: "",
            isCreateTicketModalVisible: false,
            ticketsPayload: {
                totalRecords: -1,
                data: []
            },
            isCreateTicketVisible: false,
            accountNumber: "",
            serviceIdentifier: "",
            ticketType: "",
            categoryName: "",
            categoryType: "",
            subject: "",
            description: "",
            productTypeArray: [],
            categoryNameArray: [],
            categoryTypeArray: [],
            allAccountsArray: [],
            serviceIdentifierArray: [],
            isCategoryNameEnabled: false,
            isCategoryTypeEnabled: false,
            totalTickets: 0,
            openTickets: 0,
            inprogressTickets: 0,
            completedTickets: 0,
            isTroubleTicketsModalVisible: false,
            ticketKey: "",
            createTicketStatus: 1,
            filteredTickets: {
                totalRecords: "-1",
                data: []
            },
            activeTicketClass: "totalTickets",
            isServiceIdentifierEnabled: false,
            statusNameForClosedTickets: ""
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        this.manageFeatures();
        window.addEventListener('resize', this.updateWindowDimensions);
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        Network.executeAxios("fetchServiceInfo", "POST", { accountId: this.props.cache.serviceInfo.accountId }, (serviceInfoResponse) => {
            this.handleServiceInfo(serviceInfoResponse);
            this.initializeQuerySubscriber(this.props.cache.querySubscriberResponse);
            this.setState({
                accountNumber: this.props.cache.serviceInfo.accountId
            })
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    manageFeatures() {        // 1-show feature   0-hide feature
        var createTicketStatus = 1;
        var features = this.props.userDetails.features;
        if (features.length > 0) {
            for (var i = 0; i < features.length; i++) {
                if (features[i].featureName === "CreateTicket") {
                    createTicketStatus = features[i].status;
                }
            }
        }
        this.setState({
            createTicketStatus: createTicketStatus
        })
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    formatTotalNumber = (number) => {
        if (number > 0) {
            if (number.toString().length === 1) {
                number = "0" + number;
            }
        }
        return number;
    }

    initializeQuerySubscriber(receivedResponse) {
        console.log("QUERY SUBSCRIBER RESPONSE>>>>",receivedResponse)
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        console.log("params>>>>",params)

        var firstName = "";
        var lastName = "";
        var profileId = "";
        var contactNumber = "";
        var emailId = "";

        for (var i = 0; i < params.length; i++) {
            if (params[i].id === "profile_id") {
                profileId = params[i].value;
            }
        }

        this.state.profileId = profileId;

        var accountInfoParams = [];
        try {
            accountInfoParams = receivedResponse.account_info.basic_details;
        } catch (err) {
            accountInfoParams = [];
        }
       
        for (var i = 0; i < accountInfoParams.length; i++) {
            if (accountInfoParams[i].id == "billing_name") {
                firstName = accountInfoParams[i].value;
            }
            if (accountInfoParams[i].id == "last_name") {
                lastName = accountInfoParams[i].value;
            }

            if (accountInfoParams[i].id === "notification_email_id") {
                emailId = accountInfoParams[i].value;
            }
            if (accountInfoParams[i].id === "sms_numbers") {
                contactNumber = accountInfoParams[i].value;
            }
        }

        this.setState({
            billingName: firstName + " " + lastName,
            contactNumber: contactNumber,
            emailId: emailId
        });

        Network.executeAxios("viewTicket", "POST", { "profile_id": this.state.profileId }, (response) => {
            this.handleTicketsResponse(response);
            setTimeout(() => {
                this.setState({ isLoading: false });
            }, 1000);
        });
    }


    handleTicketsResponse(receivedResponse) {
        var finalArrayForTickets = [];
        var arrayForTickets = [];
        var totalRecords = 0;
        var payLoadForTickets = {
            totalRecords: 0,
            data: ""
        }

        try {
            if (receivedResponse.ticketingDetails) {
                arrayForTickets = receivedResponse.ticketingDetails
                totalRecords = receivedResponse.totalRecordCount
            } else {
                payLoadForTickets = {
                    totalRecords: 0,
                    data: ""
                }
            }
        } catch (err) {

        }

        for (var i = 0; i < arrayForTickets.length; i++) {
            finalArrayForTickets.push(arrayForTickets[i])
        }

        var openTickets = 0;
        var inprogressTickets = 0;
        var completedTickets = 0;

        var ticketStatusArr = [];
        if (this.props.configurationValues) {
            ticketStatusArr = this.props.configurationValues.ticketStatus
        }

        for (var k = 0; k < finalArrayForTickets.length; k++) {
            for (var y = 0; y < ticketStatusArr.length; y++) {
                if (finalArrayForTickets[k].status == ticketStatusArr[y].id) {
                    finalArrayForTickets[k].status = ticketStatusArr[y].value;
                    if (finalArrayForTickets[k].status == "In progress" || finalArrayForTickets[k].status == "Customer-action-required") {
                        finalArrayForTickets[k]["statusLabel"]= "In progress"
                        inprogressTickets++
                    } else if (finalArrayForTickets[k].status == "Closed" || finalArrayForTickets[k].status == "Resolved" || finalArrayForTickets[k].status == "Cancelled") {
                        finalArrayForTickets[k]["statusLabel"]= "Closed"
                        completedTickets++
                    } else if (finalArrayForTickets[k].status == "Open" || finalArrayForTickets[k].status == "Re-open") {
                        finalArrayForTickets[k]["statusLabel"]= "Open"
                        openTickets++
                    }
                }
            }
        }

        payLoadForTickets = {
            totalRecords: totalRecords,
            data: finalArrayForTickets
        }

        this.setState({
            ticketsPayload: payLoadForTickets,
            filteredTickets: payLoadForTickets,
            totalTickets: totalRecords,
            openTickets: openTickets,
            inprogressTickets: inprogressTickets,
            completedTickets: completedTickets
        })

    }

    ticketsTableHandler = (dataObject) => {
        console.log("dataObject >>", dataObject);
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            this.setState({ "dummy": "dummy" });
        } else if (dataObject.type === "viewMore") {
            this.state.ticketKey = dataObject.ticketId
            this.setState({
                isTroubleTicketsModalVisible: true
            })
        }
    }

    viewTicketsModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            this.setState({ isTroubleTicketsModalVisible: false })
        }
    }

    populateTroubleTicketsDetailsInSlider() {

        const loadTicketsDetails = this.state.ticketsPayload.data.map((item, key) => {
            if (this.state.ticketKey === item.ticketId) {
                var description = "NA";
                if(item.description){
                    var descr = item.description;
                    description=descr.replace(/%20/g, " ");
                }
               
                return (
                    <div key={key} className="col-md-12">
                        <div className="col-md-12 p-0">
                            <div className="col-md-12 row m-0 p-0 mb-3 mt-4">
                                <div className="col-md-6 p-0">
                                    <div style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>{this.props.locales.accountNumberInSliderModal} : <span style={{ fontSize: 14, fontWeight: 700 }}>{item.accountId}</span></div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>{this.props.locales.ticketNumberInSliderModal} : <span style={{ fontSize: 14, fontWeight: 700 }}>{item.ticketId}</span></div>
                                </div>
                            </div>
                            <div className="col-md-12 row m-0 p-0">
                                <div className="col-md-6 p-0">
                                    <div style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>{this.props.locales.serviceIdentifierInSliderModal} : <span style={{ fontSize: 14, fontWeight: 700 }}>{item.serviceId}</span></div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>{this.props.locales.createdDateInSliderModal} : <span style={{ fontSize: 14, fontWeight: 700 }}>{item.createDate}</span></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 p-3 mt-5" style={{ border: '1px solid #231F20', borderRadius: 6 }}>
                            <div className="col-md-12 p-0" style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>Subject</div>
                            <div className="col-md-12 p-0 mb-3" style={{ color: '#231F20', fontSize: 14, fontWeight: 700 }}>{item.subject}</div>
                            <div className="col-md-12 p-0" style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>Description</div>
                            <div className="col-md-12 p-0 mb-3" style={{ color: '#231F20', fontSize: 14, fontWeight: 700 }}>{description}</div>
                            <div className="col-md-12 p-0" style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>Comments</div>
                            <div className="col-md-12 p-0 mb-3" style={{ color: '#231F20', fontSize: 14, fontWeight: 700 }}>{item.technicianDescription || "NA"}</div>
                        </div>
                        <div className="col-md-12 p-0 mt-5">
                            <div className="col-md-12 row m-0 p-0 mb-3 mt-4">
                                <div className="col-md-6 p-0">
                                    <div style={{ color: '#231F20', fontSize: 12, fontWeight: 500 }}>Status : <span style={{ fontSize: 14, fontWeight: 700 }}>{item.status}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        })
        if (this.state.ticketsPayload.data.length > 0) {
            return (loadTicketsDetails)
        } else {
            return (<NoDataFound />);
        }
    }

    handleInputValueChange(name, value) {
        if (name === "serviceIdentifier") {
            this.state[name] = value;
        }
        
        if (name === "ticketType") {
            this.state[name] = value;
            this.setState({ isLoading: true, isCategoryTypeEnabled: false, isCategoryNameEnabled: false, categoryType: "", categoryName: "" })
            Network.executeAxios("getCategoryType", "POST", { productType: this.state.ticketType }, (categoryTypeResponse) => {
                this.handleCategoryType(categoryTypeResponse);
            });
        }
        if (name === "categoryType") {
            this.state[name] = value;
            this.setState({ isLoading: true, isCategoryNameEnabled: false, categoryName: "" })
            Network.executeAxios("getCategoryName", "POST", { productType: this.state.ticketType, categoryType: this.state.categoryType }, (categoryNameResponse) => {
                this.handleCategoryName(categoryNameResponse);
            });
        }
        this.state[name] = value;
        this.setState({ "dummy": "dummy" });
    };

    createTicketBtnClicked = () => {
        this.setState({
            ticketType: "",
            categoryType: "",
            categoryName: "",
            subject: "",
            description: "",
            isLoading: true
        },() => {
            this.handleServiceAddressDetails();
        });
    }

    handleServiceAddressDetails = () => {
        Network.executeAxios("getProductType", "GET", {}, (productTypeResponse) => {
            this.handleProductType(productTypeResponse);
            Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                this.setState({ isLoading: false })
                try {
                    var FetchAccountDetail = fetchAccountDetailsResponse;
                    var billingAddress = FetchAccountDetail.BillingSystem.response.dataset.account_info[0].addresses[0];
                    var billingAddressLine1 = "";
                    var billingAddressLine2 = "";
                    var addressLine3 = "";
                    var addressLine4 = "";
                    var addressLine5 = "";
                    var address_id = "";
                    billingAddressLine1 = billingAddress.addr_line1;
                    billingAddressLine2 = billingAddress.addr_line2;
                    addressLine3 = billingAddress.addr_line3;
                    addressLine4 = billingAddress.addr_line4;
                    addressLine5 = billingAddress.addr_line5;
                    address_id = billingAddress.address_id
                    this.setState({
                        addressLine1: billingAddressLine1,
                        addressLine2: billingAddressLine2,
                        state: addressLine4,
                        city: addressLine3,
                        zipCode: addressLine5,
                        addressId: address_id
                    })
                }
                catch (err) {
                }
            })
        });
    }

    handleServiceInfo = (response) => {
        var serviceIdentifierArray = [];
        try {
            serviceIdentifierArray = response.BillingSystem.response.dataset.service_info;
        } catch (err) {
            serviceIdentifierArray = [];
        }

        console.log("serviceIdentifierArray>>>>",serviceIdentifierArray)
        var serviceIdentifier = "";
        if(serviceIdentifierArray && serviceIdentifierArray[0] && serviceIdentifierArray[0].service_id){
            serviceIdentifier = serviceIdentifierArray[0].service_id
        }

        console.log("serviceIdentifier>>>",serviceIdentifier)

        this.setState({
            serviceIdentifierArray: serviceIdentifierArray,
            serviceIdentifier: serviceIdentifier,
            isServiceIdentifierEnabled: true
        })
    }

    sendEmail() {
        const supportEmail = this.props.locales.getHelpEmailAddressTextInSwal;
        if (supportEmail) {
            window.open(`mailto:${supportEmail}`);
        } else {
            console.log("Support email is not available");
        }
    }
    

    makeCall(){
         const supportCall = this.props.locales.getHelpPhoneRedirectionNumber;
        if (supportCall) {
            window.open(`tel:${supportCall}`)
        } else {
            console.log("Contact number is not available");
        }
    }

    handleCategoryType = (response) => {
        var categoryTypeArray = [];
        try {
            if (response.metadataValue && response.metadataValue.categoryTypeNames) {
                categoryTypeArray = response.metadataValue.categoryTypeNames
                categoryTypeArray.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
            }
        } catch (err) {

        }
        if (categoryTypeArray.length > 0) {
            this.setState({
                categoryTypeArray: categoryTypeArray,
                isLoading: false,
                isCategoryTypeEnabled: true
            })
        } else {
            this.setState({isLoading: false})
        }
    }

    handleCategoryName = (response) => {
        var categoryNameArray = []
        try {
            if (response.metadataValue && response.metadataValue.categoryTypes) {
                categoryNameArray = response.metadataValue.categoryTypes
                categoryNameArray.sort((a, b) => a.categoryTypeName.localeCompare(b.categoryTypeName));
            }
        } catch (err) {

        }
        if (categoryNameArray.length > 0) {
            this.setState({
                categoryNameArray: categoryNameArray,
                isLoading: false,
                isCategoryNameEnabled: true,
                categoryName: categoryNameArray[0].categoryTypeId
            })
        } else {
            this.setState({ isLoading: false })
        }
    }

    handleProductType = (response) => {
        var productTypeArray = []
        try {
            if (response.metadataValue && response.metadataValue.productTypes) {
                productTypeArray = response.metadataValue.productTypes;
                productTypeArray.sort((a, b) => a.productName.localeCompare(b.productName));
            }
        } catch (err) {

        }

        if (productTypeArray.length > 0) {
            this.setState({
                productTypeArray: productTypeArray,
                isCreateTicketVisible: true,
                isLoading: false
            })
        }
    }

    createTicketCancelBtnClicked = () => {
        this.setState({
            isCategoryTypeEnabled: false, isCategoryNameEnabled: false, categoryType: "", categoryName: "", isCreateTicketVisible: false, isServiceIdentifierEnabled: false
        })
    }

    createTicketSubmitBtnClicked = () => {
        if (ValidateForm.inputFieldMandatoryCheck("createTicketDiv", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("createTicketDiv", this.props.locales, false)) {
                this.setState({ isLoading: true })
                var ticketDetails = {
                    "productType": this.state.ticketType,
                    "categoryNameId": this.state.categoryName,
                    "categoryTypeId": this.state.categoryType,
                    "priority": "1",
                    "subject": this.state.subject,
                    "description": this.state.description,
                    "customerName": this.state.billingName,
                    "customerContactNumber": this.state.contactNumber,
                    "customerEmailId": this.state.emailId,
                    "mvno_id": "200",
                    "address_line_1": this.state.addressLine1,
                    "address_line_2": this.state.addressLine2,
                    "state": this.state.state,
                    "city": this.state.city,
                    "postalCode": this.state.zipCode,
                    "users": "1",
                    "masterTicket": "0",
                    "isWorkOrder": "0",
                    "serviceId": this.state.serviceIdentifier,
                    "accountId": this.state.accountNumber,
                    "profileId": this.state.profileId,
                    "severityLevel": "2",
                    "assignee": "",
                    "resultCode": "4"
                }
                Network.executeAxios("createTicket", "POST", ticketDetails, (createResponse) => {
                    if (createResponse.resultCode && createResponse.resultCode === "0") {
                        Swal.fire(this.props.locales.ticketCreatedSuccessMsgSwal, "", "");
                        this.setState({ isCreateTicketVisible: false });
                        setTimeout(() => {
                            Network.executeAxios("viewTicket", "POST", { "profile_id": this.state.profileId }, (response) => {
                                this.handleTicketsResponse(response);
                                setTimeout(() => {
                                    this.setState({ isLoading: false, isCategoryNameEnabled: false, isCategoryTypeEnabled: false });
                                }, 200);
                            });
                        }, 1000);
                    } else {
                        Swal.fire(this.props.locales.ticketCreatedFailureMsgSwal, "", "");
                        setTimeout(() => {
                            this.setState({ isCreateTicketVisible: false, isLoading: false, isCategoryNameEnabled: false, isCategoryTypeEnabled: false });
                        }, 500);
                    }

                });
            }
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        return (
            <div id="serviceCenterContainer" className="animated fadeIn">
                <div className="px-sm-4 px-0 ml-2 mb-2 col-md-12 p-0 py-4 mx-auto">
                    <div className="chooseAddonHead" style={{borderBottom:'1px solid #D6D6D6'}}>{this.props.locales.serviceCenterMainHeading}</div>
                </div>
                {this.state.isCreateTicketVisible ?
                    this.createTicketComponent()
                    :
                    this.viewTicketComponent()
                }

                <div className="col-md-12 mt-4 mb-5">
                    <div className="col-md-12 p-0 mb-3 chooseAddonHead" style={{borderBottom: '1px solid #d6d6d6' }}>{this.props.locales.getHelpInServiceCenter}</div>
                    <div className="col-md-12 p-0 d-flex mb-3 flex-md-row flex-column justify-content-center">
                        <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-4 m-1 justify-content-center' style={{cursor: 'pointer'}} onClick={() => this.makeCall()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="86.985" height="86.992" viewBox="0 0 86.985 86.992">
                            <path id="Path_3493" data-name="Path 3493" d="M1767.92,3408.44a3.2,3.2,0,0,1-.96,2.35c-2.19,2.19-3.49,3.5-6.48,6.49-21.47,21.47-97.23-54.28-75.75-75.76l6.48-6.48a3.168,3.168,0,0,1,2.36-.96,3.133,3.133,0,0,1,2.33,1.01l19.33,20.15a3.3,3.3,0,0,1-.05,4.6l-9.12,9.11c6.17,11.11,15.33,19.98,26.98,26.98l9.12-9.11a3.278,3.278,0,0,1,4.59-.05l20.16,19.33a3.192,3.192,0,0,1,1.01,2.34Z" transform="translate(-1680.935 -3334.08)" fill="#fff" fill-rule="evenodd"/>
                            </svg>
                            <div className='supportCardTxt p-2'>Call us</div>
                        </div>
                        <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-3 m-1' style={{cursor: 'pointer'}} onClick={() => this.sendEmail()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="101.4" height="67.68" viewBox="0 0 101.4 67.68">
                            <g id="Group_3579" data-name="Group 3579" transform="translate(-672.3 -536.4)">
                                <path id="Path_3494" data-name="Path 3494" d="M2009.49,3389.74l-28.26,26.8v-49.93Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                                <path id="Path_3495" data-name="Path 3495" d="M2082.63,3366.61v49.56l-28.05-26.61Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                                <path id="Path_3496" data-name="Path 3496" d="M2077.86,3421.08h-91.47l28.44-26.98,17.1,14,17.31-14.16Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                                <path id="Path_3497" data-name="Path 3497" d="M2082.63,3353.4v4.34l-50.7,41.5-50.7-41.5v-4.34Z" transform="translate(-1308.93 -2817)" fill="#fff" fill-rule="evenodd"/>
                            </g>
                            </svg>
                            <div className='supportCardTxt p-2'>Mail us</div>

                        </div>
                        <div className='rechargeCardTopMiniCardInactive col-md-2 col-sm-12 p-3 m-1 justify-content-center' style={{cursor: 'pointer'}} onClick={() => { Swal.fire("Our customer care number is ", this.props.locales.getHelpPhoneSupportTextInSwal, ""); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="62.53" height="93.14" viewBox="0 0 62.53 93.14">
                            <path id="Path_3498" data-name="Path 3498" d="M2325.12,3371.33l.66-.66c16.69-.53,24.3-5.91,24.3-14.58v-.26c0-7.36-5.65-12.48-15.11-12.48-8.28,0-15.11,3.68-21.41,10.38l-9.85-10.51c7.62-8.67,17.47-14.58,31.66-14.58,18.39,0,30.87,10.25,30.87,26.67v.26c0,16.55-11.96,24.04-26.54,26.54l-1.31,10.51h-10.64l-2.63-21.28Zm-1.18,32.32h17.6v18.13h-17.6Z" transform="translate(-2303.71 -3328.64)" fill="#fff"/>
                            </svg>
                            <div className='supportCardTxt p-2'>Service Request</div>
                        </div>
                        {/* <div className="getHelpBox d-flex justify-content-start mr-3 mb-sm-0 mb-3" onClick={() => this.sendEmail()}>
                            <div className="py-3 px-4"><img alt="" src={Email} /></div>
                            <div className="pr-4" style={{ display: 'table', height: '100%' }}>
                                <div style={{ color: '231F20', fontSize: 14, fontWeight: 500, verticalAlign: 'middle', display: 'table-cell' }}>{this.props.locales.internetAndEduInGetHelp}</div>
                            </div>
                        </div>
                        <div className="getHelpBox justify-content-start d-none d-sm-flex" onClick={() => { Swal.fire("Our customer care number is ", "(268) 480-7375 or 611", ""); }}>
                            <div className="py-3 px-4"><img alt="" src={PhoneBlk} /></div>
                            <div className="pr-4" style={{ display: 'table', height: '100%' }}>
                                <div style={{ color: '231F20', fontSize: 14, fontWeight: 500, verticalAlign: 'middle', display: 'table-cell' }}>{this.props.locales.phoneAndEduInGetHelp}</div>
                            </div>
                        </div>

                        <div className="getHelpBox d-flex justify-content-start d-md-none" onClick={() => this.makeCall()}>
                            <div className="py-3 px-4"><img alt="" src={PhoneBlk} /></div>
                            <div className="pr-4" style={{ display: 'table', height: '100%' }}>
                                <div style={{ color: '231F20', fontSize: 14, fontWeight: 500, verticalAlign: 'middle', display: 'table-cell' }}>{this.props.locales.phoneAndEduInGetHelp}</div>
                            </div>
                        </div> */}

                    </div>
                </div>

                <SliderModal
                    isVisible={this.state.isTroubleTicketsModalVisible}
                    uniqueModalReferenceId="troubleTickets"
                    mainHeading={this.props.locales.troubleTicketSliderMainHeading + " - " + this.state.ticketKey}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1.5}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={false}
                    contentPartBackgroundColor="#f7f7f7"
                    cancelButtonText="Close"
                    callback={this.viewTicketsModalHandler}
                >
                    <div className="col-md-12" id="troubleTickets">
                        <table className="table">
                            {this.populateTroubleTicketsDetailsInSlider()}
                        </table>

                    </div>
                </SliderModal>


            </div>
        );
    }

    statusClicked = (type) => {
        var filteredTickets = []
        this.state.activeTicketClass = type
        if (type === "totalTickets") {
            this.state.filteredTickets = this.state.ticketsPayload
        } else {
            for (var i = 0; i < this.state.ticketsPayload.data.length; i++) {
                if (this.state.ticketsPayload.data[i].statusLabel === type) {
                    filteredTickets.push(this.state.ticketsPayload.data[i])
                }
            }

            this.state.filteredTickets = {
                totalRecords: filteredTickets.length,
                data: filteredTickets
            }
        }
        this.setState({ "dummy": "dummy" })

    }

    viewTicketComponent() {
        return (
            <div className="col-md-12 p-0 viewTicketsContainer">
                <div className="col-md-12 p-0 px-sm-4 px-md-2 px-lg-4 px-0">
                    <div className="px-sm-3 px-md-1 px-0 pb-2 cardOuterContainer ticketsHistoryDiv mx-auto" >
                        <div className="col-md-12 p-0 ticketsHistoryLabel mx-auto py-2 px-sm-4 px-2">{this.props.locales.ticketsHistoryHeadingInServiceCenter}</div>
                        <div className="col-md-12 p-0 row mx-auto  justify-content-around">

                            <div className="ticketsHistoryDetailsBox1 d-flex justify-content-between py-sm-3 py-2 px-sm-4 px-md-2 px-0 align-items-center"
                                style={this.state.activeTicketClass === "Open" ? { border: '1px solid rgba(2,133,202,0.2)', backgroundColor: 'rgba(2,133,202,0.2)', cursor: 'pointer' } : { cursor: 'pointer' }}
                                onClick={() => this.statusClicked('Open')}>
                                {this.state.activeTicketClass === "Open" ?
                                    <div className="pt-0 pl-2"><img alt="" src={open} /></div>

                                    :
                                    <div className="pt-0 pl-2"><img alt="" src={openGrey} /></div>
                                }
                                <div className="pr-4">
                                    <div className="ticketCount" style={this.state.activeTicketClass === "Open" ? { color: '#E21736', fontWeight: 'bold' } : { color: '#E21736', fontWeight: 500 }} >{this.formatTotalNumber(this.state.openTickets)}</div>
                                    <div className="ticketStatusLabel">{this.props.locales.openTicketsSubHeadingInServiceCenter}</div>
                                </div>
                            </div>

                            <div className="ticketsHistoryDetailsBox1  mb-2 d-flex justify-content-between py-sm-3 py-2 px-sm-4 px-md-2 px-0 align-items-center"
                                style={this.state.activeTicketClass === "In progress" ? { border: '1px solid rgba(2,133,202,0.2)', backgroundColor: 'rgba(2,133,202,0.2)', cursor: 'pointer' } : { cursor: 'pointer' }}
                                onClick={() => this.statusClicked('In progress')}>

                                {this.state.activeTicketClass === "In progress" ?
                                    <div className="pt-0 pl-2"><img alt="" src={inprogress} /></div>
                                    :
                                    <div className="pt-0 pl-2"><img alt="" src={inprogressGrey} /></div>
                                }
                                <div className="pr-4">
                                    <div className="ticketCount" style={this.state.activeTicketClass === "In progress" ? { color: '#FF8F18', fontWeight: 'bold' } : { color: '#FF8F18', fontWeight: 500 }}>{this.formatTotalNumber(this.state.inprogressTickets)}</div>
                                    <div className="ticketStatusLabel">{this.props.locales.inProgressSubHeadingInServiceCenter}</div>
                                </div>
                            </div>

                            <div className="ticketsHistoryDetailsBox1  mb-2 d-flex justify-content-between py-sm-3 py-2 px-sm-4 px-md-2 px-0 align-items-center"
                                style={this.state.activeTicketClass === "Closed" ? { border: '1px solid rgba(2,133,202,0.2)', backgroundColor: 'rgba(2,133,202,0.2)', cursor: 'pointer' } : { cursor: 'pointer' }}
                                onClick={() => this.statusClicked('Closed')}>
                                {this.state.activeTicketClass === "Closed" ?
                                    <div className="pt-0 pl-2"><img alt="" src={completed} /></div>
                                    :
                                    <div className="pt-0 pl-2"><img alt="" src={completedGrey} /></div>
                                }
                                <div className="pr-4" style={{ width: 86 }}>
                                    <div className="ticketCount" style={this.state.activeTicketClass === "Closed" ? { color: '#07B23D', fontWeight: 'bold' } : { color: '#07B23D', fontWeight: 500 }}>{this.formatTotalNumber(this.state.completedTickets)}</div>
                                    <div className="ticketStatusLabel">{this.props.locales.closedSubHeadingInServiceCenter}</div>
                                </div>
                            </div>

                            <div className="ticketsHistoryDetailsBox1 mb-2 d-flex justify-content-between py-sm-3 py-2 px-sm-4 px-md-2 px-0 align-items-center"
                                style={this.state.activeTicketClass === "totalTickets" ? { border: '1px solid rgba(2,133,202,0.2)', backgroundColor: 'rgba(2,133,202,0.2)', cursor: 'pointer' } : { cursor: 'pointer' }}
                                onClick={() => this.statusClicked('totalTickets')}>

                                {this.state.activeTicketClass === "totalTickets" ?
                                    <div className="pt-0 pl-2"><img alt="" src={total} /></div>

                                    :
                                    <div className="pt-0 pl-2"><img alt="" src={totalGrey} /></div>
                                }
                                <div className="pr-4">
                                    <div className="ticketCount" style={this.state.activeTicketClass === "totalTickets" ? { color: '#231F20', fontWeight: 'bold' } : { color: '#231F20', fontWeight: 500 }}>{this.formatTotalNumber(this.state.totalTickets)}</div>
                                    <div className="ticketStatusLabel">{this.props.locales.allTicketsSubHeadingInServiceCenter}</div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div className="col-md-12 px-sm-4 px-0 p-0 mt-4 mb-5 pb-3" id="ticketsTablePart">
                    <div className="col-md-12 p-0">
                        <div className="col-md-12 d-flex justify-content-between pb-2 p-0" style={{ borderBottom: '1px solid #d6d6d6' }}>
                            {this.state.activeTicketClass === "Open" ?
                                <div className="chooseAddonHead" >{this.props.locales.openTicketsSubHeadingInServiceCenter} | {this.state.filteredTickets.data.length}</div>
                                :
                                null}
                            {this.state.activeTicketClass === "Closed" ?
                                <div className="chooseAddonHead" >{this.props.locales.closedTicketsSectionInServiceCenter} | {this.state.filteredTickets.data.length}</div>
                                :
                                null}
                            {this.state.activeTicketClass === "In progress" ?
                                <div className="chooseAddonHead">{this.props.locales.inProgressTicketsSectionInServiceCenter} | {this.state.filteredTickets.data.length}</div>
                                :
                                null}
                            {this.state.activeTicketClass === "totalTickets" ?
                                <div className="chooseAddonHead">{this.props.locales.allTicketsSubHeadingInServiceCenter} | {this.state.filteredTickets.data.length}</div>
                                :
                                null}

                            {this.state.createTicketStatus == 1 ?
                                <div className="brandColorButton d-none d-sm-block text-center px-3 py-2 createTktLgBtn" onClick={() => { this.createTicketBtnClicked() }}>{this.props.locales.createTicketButtonTextInServiceCenter}</div>
                                : null}

                            <div className="brandColorButton d-md-none d-flex align-items-center justify-content-center" style={{ width: 35, height: 35 }} onClick={() => { this.createTicketBtnClicked() }}>+</div>

                        </div>
                    </div>
                    <div className="col-md-12 pt-4 px-0">
                        <div className="col-md-12 pb-1 cardOuterContainer viewTicketOuterDiv" style={{ overflow: 'auto', backgroundColor: '#ffffff', boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', borderRadius: 6 }}>
                            <TableComponent
                                headerArray={[
                                    {
                                        key: "ticketId",
                                        label: "Ticket ID"
                                    },
                                    {
                                        key: "createDate",
                                        label: "Created Date & Time"
                                    },
                                    {
                                        key: "subject",
                                        label: "Subject"
                                    },
                                    {
                                        key: "status",
                                        label: "Status"
                                    },
                                    {
                                        key: "action",
                                        label: "View",
                                        formatter: (rowData, callback) => {
                                            return (
                                                <div>
                                                    <img src={viewIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "viewMore", "ticketId": rowData.ticketId })} />
                                                </div>
                                            );

                                        }
                                    }
                                ]}
                                payload={this.state.filteredTickets}
                                isSearchRequired={true}
                                noDataContentText={this.props.locales.noDataContentTextForTickets}
                                limit={10}
                                tableUniqueId="ticketsTable"
                                callback={this.ticketsTableHandler}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    createTicketComponent() {
        return (
            <div className="col-md-12 p-0 viewTicketsContainer">
                <div className="col-md-12 p-0 col-md-12 p-0 px-sm-3 px-0">
                    <div className="px-sm-3 px-0 py-2 cardOuterContainer createTicketDiv">
                        <div className="col-md-12 p-0 pl-2 ticketsHistoryLabel mb-3">{this.props.locales.createTicketHeadingInServiceCenter}</div>
                        <div className="col-md-12 p-0 row m-0 createTicketInnerDiv" id="createTicketDiv">
                            <div className="col-md-4 p-0">
                                <div className="form-group col-md-12 float-left">
                                    <label className="formGroup_label_new">{this.props.locales.accountNumLabelInCreateTicket}</label>
                                    <div className="input-group">
                                        <input type="text"
                                            className="form-control input_data formGroup_value_withoutStyle"
                                            value={this.state.accountNumber} onChange={(event) => this.handleInputValueChange("accountNumber",event.target.value)}
                                            style={{ height: 40, fontSize: 14 }}
                                            disabled={true}
                                        />
                                    </div>

                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                            {this.state.isServiceIdentifierEnabled ?
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.serviceNameLabelInCreateTicket}</label>
                                        <select required className="form-control mandatoryField_ input_data custom-select mr-sm-2 formGroup_value"
                                            value={this.state.serviceIdentifier}
                                            onChange={(event) => this.handleInputValueChange("serviceIdentifier", event.target.value)}>
                                            {/* <option value="">{this.props.locales.chooseOptionValueInCreateTicket}</option> */}
                                            {this.state.serviceIdentifierArray.map((item, key) => {
                                                return (
                                                    <option key={key} value={item.service_id}>{item.service_name} ({item.service_id})</option>
                                                )
                                            })
                                            }
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                                :
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.serviceNameLabelInCreateTicket}</label>
                                        <select required disabled className="form-control mandatoryField_ input_data_ custom-select mr-sm-2 formGroup_value"
                                            value={this.state.serviceIdentifier} style={{ cursor: 'not-allowed' }}
                                            onChange={(event) => this.handleInputValueChange("serviceIdentifier", event.target.value)}>
                                            <option value="" disabled selected hidden>{this.props.locales.serviceNameOptionValueInCreateTicket}</option>
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                            }
                            <div className="col-md-4 p-0">
                                <div className="form-group col-md-12 float-left">
                                    <label className="formGroup_label_new">{this.props.locales.ticketTypeLabelInServiceCenter}</label>
                                    <select required className="form-control mandatoryField input_data custom-select mr-sm-2 formGroup_value"
                                        value={this.state.ticketType}
                                        onChange={(event) => this.handleInputValueChange("ticketType", event.target.value)}>
                                        <option value="" disabled selected hidden>{this.props.locales.ticketTypeOptionValueInCreateTicket}</option>
                                        {this.state.productTypeArray.map((item, key) => {
                                            return (
                                                <option key={key} value={item.productId}>{item.productName}</option>
                                            )
                                        })
                                        }
                                    </select>
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                            {this.state.isCategoryTypeEnabled ?
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.categoryTypeLabelInServiceCenter}</label>
                                        <select required className="form-control mandatoryField input_data custom-select mr-sm-2 formGroup_value"
                                            value={this.state.categoryType}
                                            onChange={(event) => this.handleInputValueChange("categoryType", event.target.value)}>
                                            <option value="" disabled selected hidden>{this.props.locales.categoryTypeOptionValueInCreateTicket}</option>
                                            {this.state.categoryTypeArray.map((item, key) => {
                                                return (
                                                    <option key={key} value={item.categoryTypeId}>{item.categoryName}</option>
                                                )
                                            })
                                            }
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                                :
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.categoryTypeLabelInServiceCenter}</label>
                                        <select required disabled className="form-control mandatoryField_ input_data custom-select mr-sm-2 formGroup_value"
                                            value={this.state.categoryType} style={{ cursor: 'not-allowed' }}
                                            onChange={(event) => this.handleInputValueChange("categoryType", event.target.value)}>
                                            <option value="" disabled selected hidden>{this.props.locales.categoryTypeOptionValueInCreateTicket}</option>
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                            }
                            {this.state.isCategoryNameEnabled ?
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.categoryNameLabelInCreateTicket}</label>
                                        <select required className="form-control mandatoryField input_data custom-select mr-sm-2 formGroup_value"
                                            value={this.state.categoryName}
                                            onChange={(event) => this.handleInputValueChange("categoryName", event.target.value)}>
                                            {this.state.categoryNameArray.map((item, key) => {
                                                return (
                                                    <option key={key} value={item.categoryTypeId}>{item.categoryTypeName}</option>
                                                )
                                            })
                                            }
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                                :
                                <div className="col-md-4 p-0">
                                    <div className="form-group col-md-12 float-left">
                                        <label className="formGroup_label_new">{this.props.locales.categoryNameLabelInCreateTicket}</label>
                                        <select required disabled className="form-control mandatoryField_ input_data custom-select mr-sm-2 formGroup_value"
                                            value={this.state.categoryName} style={{ cursor: 'not-allowed' }}
                                            onChange={(event) => this.handleInputValueChange("categoryName", event.target.value)}>
                                            <option value="" disabled selected hidden>{this.props.locales.categoryNameOptionValueInCreateTicket}</option>
                                        </select>
                                        <div className="errorDesc"></div>
                                    </div>
                                </div>
                            }
                            <div className="col-md-4 p-0">
                                <div className="form-group col-md-12 float-left">
                                    <label className="formGroup_label_new">{this.props.locales.subjectLabelInCreateTicket}</label>
                                    <textarea type="text" className="form-control formGroup_value mandatoryField input_data validDescription"
                                        value={this.state.subject} placeholder={this.props.locales.subjectLabelInCreateTicket}
                                        onChange={(event) => this.handleInputValueChange("subject", event.target.value)} />
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                            <div className="col-md-4 p-0">
                                <div className="form-group col-md-12 float-left">
                                    <label className="formGroup_label_new">{this.props.locales.descriptionLabelInCreateTicket}</label>
                                    <textarea type="text" className="form-control formGroup_value mandatoryField input_data validDescription"
                                        value={this.state.description} placeholder={this.props.locales.descriptionLabelInCreateTicket}
                                        onChange={(event) => this.handleInputValueChange("description", event.target.value)} />
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                            <div className="col-md-4 my-auto">
                                <div className="d-flex m-0 justify-content-between">
                                    <Button className="createTicketCancelBtn mt-2" style={{ marginRight: 30 }} onClick={() => { this.createTicketCancelBtnClicked() }}>
                                        {this.props.locales.cancelButtonTextInCreateTicket}
                                    </Button>
                                    <Button className="brandColorButton createTicketSubmitBtn mt-2" onClick={() => { this.createTicketSubmitBtnClicked() }}>
                                        {this.props.locales.createButtonTextInCreateTicket}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

const ServiceCenterComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ServiceCenterComponent)

export default ServiceCenterComponentContainer;
